import { TFunction } from 'i18next';
import { ClockWatch } from 'shared/assets/icons';
import { FilterNumberRangeOption, FilterOptionType } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';

export type Options = {
  t: TFunction;
};

export const createDurationFilter = ({
  t,
}: Options): FilterNumberRangeOption => ({
  id: FilterOptionKeys.Duration,
  label: t('context-menus.filtering.task.filters.duration.title'),
  minLabel: t('context-menus.filtering.task.filters.duration.more.label'),
  maxLabel: t('context-menus.filtering.task.filters.duration.less.label'),
  placeholder: t('context-menus.filtering.task.filters.duration.placeholder'),
  icon: ClockWatch,
  type: FilterOptionType.NumberRange,
});
